import api from './index'

// 外链推荐相关API
export const externalLinksAPI = {
  // 获取外链列表
  getList: (params?: {
    limit?: number
    category?: string
  }) => api.get('/external-links/list', { params }),

  // 提交外链
  submit: (data: {
    title: string
    description?: string
    url: string
    category: 'live' | 'video' | 'blog' | 'other'
    hours?: number
  }) => api.post('/external-links/submit', data),

  // 获取用户的外链列表
  getMyLinks: () => api.get('/external-links/my-links'),

  // 获取用户当前积分
  getMyPoints: () => api.get('/external-links/my-points'),

  // 停止外链
  stopLink: (id: number) => api.post(`/external-links/${id}/stop`),

  // 修改外链
  updateLink: (id: number, data: {
    title?: string
    description?: string
    url?: string
    category?: 'live' | 'video' | 'blog' | 'other'
  }) => api.put(`/external-links/${id}`, data),

  // 增加浏览次数
  addView: (id: number) => api.post(`/external-links/${id}/view`)
}

// 外链数据类型定义
export interface ExternalLink {
  id: number
  user_callsign: string
  title: string
  description?: string
  url: string
  category: 'live' | 'video' | 'blog' | 'other'
  points_per_hour: number
  total_points_spent: number
  start_time: string
  end_time?: string
  view_count: number
  created_at: string
  status?: 'pending' | 'approved' | 'rejected'
  is_active?: boolean
}

// 外链分类选项
export const linkCategories = [
  { label: '直播', value: 'live', icon: 'fas fa-video' },
  { label: '视频', value: 'video', icon: 'fas fa-play-circle' },
  { label: '博客', value: 'blog', icon: 'fas fa-blog' },
  { label: '其他', value: 'other', icon: 'fas fa-link' }
]

// 获取分类显示名称
export const getCategoryLabel = (category: string) => {
  const found = linkCategories.find(c => c.value === category)
  return found ? found.label : '其他'
}

// 获取分类图标
export const getCategoryIcon = (category: string) => {
  const found = linkCategories.find(c => c.value === category)
  return found ? found.icon : 'fas fa-link'
} 